import { render, staticRenderFns } from "./ModalConfirmGantiProduk.vue?vue&type=template&id=3f11295c&"
import script from "./ModalConfirmGantiProduk.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmGantiProduk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports